import { Roles } from 'constants/AdminConstants';
import { getAnalyticsFromWindow } from './window';
// Define analytics events as const for better type inference
var events = {
    activity_added: 'Activity Added',
    onboarding_completed: 'Onboarding Completed',
    onboarding_step_1: 'Onboarding Step 1 Completed',
    onboarding_step_2: 'Onboarding Step 2 Completed',
    onboarding_step_3: 'Onboarding Step 3 Completed',
    signed_in: 'User Signed In'
};
var group = function (company) {
    var getStatus = function (status) {
        switch (status) {
            case 2:
            case 3:
                return 'Paid';
            case 4:
                return 'Cancelled';
            case 1:
            default:
                return 'Unpaid';
        }
    };
    var analytics = getAnalyticsFromWindow();
    if (analytics && company) {
        try {
            analytics.group(company.account.id.toString(), {
                name: company.account.account_name,
                avatar: company.account.logo,
                plan: parseInt(company.account.status, 10) === 2 ? 'Monthly' : '',
                status: getStatus(parseInt(company.account.status, 10)),
                numberOfTrackables: company.products.length,
                numberOfUsers: company.users.length,
                numberOfAllGames: company.games_list.all.length,
                numberOfOwnedGames: Object.keys(company.games_list.owned).length,
                numberOfGuestGames: company.games_list.guest.length,
                onboardingCompleted: company.account.onboarding_completed
            }).catch(function (exception) {
                console.warn(exception);
            });
        }
        catch (exception) {
            console.warn(exception);
        }
    }
};
var identify = function (user) {
    var analytics = getAnalyticsFromWindow();
    if (analytics && user) {
        analytics.identify(user.id.toString(), {
            name: user.user_name,
            email: user.email,
            avatar: user.upload_url,
            role: parseInt(user.role_id, 10) === Roles.ADMINISTRATOR ? 'Coach' : 'Player'
        });
    }
};
var track = function (event, properties, options, callback) {
    if (properties === void 0) { properties = {}; }
    if (options === void 0) { options = {}; }
    var analytics = getAnalyticsFromWindow();
    if (analytics) {
        analytics.track(event, properties, options, callback);
    }
};
// SHOULD NOW BE DEPRECATED SEE RouteChangeTracker.react.ts
// @deprecated
var trackRouteChanges = function (history) {
    var analytics = getAnalyticsFromWindow();
    var previousLocation = null;
    if (analytics && (history === null || history === void 0 ? void 0 : history.listen)) {
        history.listen(function (location) {
            if (previousLocation !== location) {
                previousLocation = location;
                analytics.page();
            }
        });
    }
    return history;
};
export { events, group, identify, track, trackRouteChanges };
